<template>
  <div v-if="event && race">
    <v-card-title class="headline pb-0">{{$t('profile.activities.entry.workout-videos')}}</v-card-title>
    <v-card-text v-if="!videoBadges">
      <v-progress-circular indeterminate :size="50" :width="5" color="grey" class="mx-a"></v-progress-circular>
    </v-card-text>
    <v-divider />
    <template v-for="(badge, idx) in videoBadges">
      <v-card :key="idx" elevation="0" tile :class="shouldHighlight(badge) ? 'highlighted' : ''" style="position:relative;" :to="{ name: 'activityWorkoutVideo', params: {eventId: event.id, raceId: race.id, badgeId: badge.id }}">
        <div class="status-overlay" style="position:absolute;">
          <v-badge v-if="videoIdsCompleted && videoIdsCompleted.indexOf(badge.id)>=0" color="green">
            <template v-slot:badge>
              <v-icon size="10">
                fa-check
              </v-icon>
            </template>
          </v-badge>
          <v-badge v-else-if="videoIdsCompleted && badge.till && $helpers.isPastTimestamp(badge.till)" color="red">
            <template v-slot:badge>
              <v-icon size="10">
                fal fa-times
              </v-icon>
            </template>
          </v-badge>
          <v-badge v-else-if="videoIdsCompleted && badge.till && videoIdsLocked && videoIdsLocked.indexOf(badge.id)>=0" color="grey">
            <template v-slot:badge>
              <v-icon size="10">
                fal fa-history
              </v-icon>
            </template>
          </v-badge>
          <v-badge v-else-if="videoIdsCompleted && !badge.from && !badge.till" color="transparent">
            <template v-slot:badge>
              <v-icon color="transparent">
              </v-icon>
            </template>
          </v-badge>
          <v-badge v-else-if="videoIdsCompleted" color="orange">
            <template v-slot:badge>
              <v-icon size="10">
                fa fa-exclamation
              </v-icon>
            </template>
          </v-badge>
          <v-badge v-else>
            <template v-slot:badge>
              <v-icon>
                fa-spinner fa-spin
              </v-icon>
            </template>
          </v-badge>
        </div>

        <v-row>
          <v-col cols="12" class="d-flex align-center">
            <div class="d-flex flex-column align-left ps-8">
              <p class="mb-0">{{ badge.name }}</p>
              <p v-if="videoIdsCompleted && videoIdsCompleted.indexOf(badge.id)>=0" class="mb-0 text-muted">{{ $t('shared.completed') }}</p>
              <div v-else-if="badge && badge.from && badge.till" class="text-muted">
                <p v-if="$helpers.isTimeInBetween(badge.from, badge.till)" class="mb-0">{{ $t('profile.activities.workouts.complete-before', {'date': $options.filters.localDate(badge.till)}) }}</p>
                <p v-else-if="$helpers.isPastTimestamp(badge.till)" class="mb-0">{{ $t('profile.activities.workouts.available-till', {'date': $options.filters.localDate(badge.till)}) }}</p>
                <p v-else-if="$helpers.isFutureTimestamp(badge.from)" class="mb-0">{{ $t('profile.activities.workouts.available-on', {'date': $options.filters.localDate(badge.from)}) }}</p>
              </div>
            </div>
            <v-spacer />
            <workout-video-card 
              :item="videosAvailable.find(x => x.id == badge.id) || videosUnavailable.find(x => x.id == badge.id)"  
              minimal
              class="my-2"
              :style="{'width':'100px', 'opacity': videoIdsLocked && videoIdsLocked.indexOf(badge.id)>=0 ? '.4' : '1'}"
              :route="{ name: 'activityWorkoutVideo', params: {eventId: event.id, raceId: race.id, badgeId: badge.id }}"
              />
            <v-btn icon class="mx-4 trailing">
              <v-icon v-if="(videoIdsAvailable && videoIdsAvailable.indexOf(badge.id)>=0) || (badge.till && $helpers.isPastTimestamp(badge.till))" color="primary">
                fa-chevron-right
              </v-icon>
              <v-icon v-else color="grey">fa-history</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-divider :key="`sep${idx}`" />
    </template>


  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DateTime } from 'luxon';
import { EventBus } from '@/plugins/eventbus.js';
import activityService from "@/services/activityService";
import eventService from "@/services/eventService";
import tenants from '@/data/tenants.config'
import WorkoutVideoCard from './workouts/WorkoutVideoCard.vue';
const tenant = tenants.current();

export default {
  name: "RaceResultsVideos",
  components: {
    WorkoutVideoCard
  },
  props: {
      event: Object,
      race: Object,
      meta: Object,
      badges: Array,
  },
  data() {
    return {
      videosAvailable: null,
      videosUnavailable: null,
      videosCompleted: null,
      videoIdsAvailable: null,
      videoIdsCompleted: null,
      videoIdsLocked: null,
    };
  },
 
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      if (this.race && this.race.scoring === 'BADGES' && this.race.badge_scoring === 'WORKOUT_VIDEOS') {
        var response = (await eventService.getWorkoutVideos(this.event.id, this.race.id)).data;
        console.log('LOADING videos', response); 
        this.videosAvailable = response.available;
        this.videoIdsAvailable = response.available.map(x => x.id);
        this.videosUnavailable = response.unavailable;
        this.videoIdsLocked = response.unavailable.map(x => x.id);

        if (this.user) {
          var statusResponse = (await activityService.getWorkoutVideos(this.event.id, this.race.id)).data;
          console.log('LOADING video status', statusResponse); 
          if (statusResponse.completed) {
            this.videoIdsCompleted = statusResponse.completed.map(x => x.id);
          console.log('LOADING this.videoIdsCompleted', this.videoIdsCompleted); 
          }
        }
      }
    },


    shouldHighlight(badge) {
      return badge.from 
          && badge.till 
          && this.videoIdsCompleted
          && this.videoIdsCompleted.indexOf(badge.id) == -1
          && this.$helpers.isTimeInBetween(badge.from, badge.till)
          ;
    },

    getBadgeForWorkout(workout) {
      return this.badges && this.badges.find(x => x.id == workout.id);
    },


  },
  watch: {
  },
  computed: {
    videoBadges() {
      return this.badges && this.badges.filter(x => x.metric == 'WORKOUT_VIDEO');
    },
    ...mapGetters({
      user: "user"
    })
  },

};
</script>
<style lang="scss">

  .v-card{ 
    .status-overlay {
      position: absolute;
      top: -17px;
      left: 0;
      .v-badge .v-badge__badge {
        border-radius: 0;
        clip-path: polygon(100% 0, 0 0, 0 100%);
        width: 30px;
        height: 30px;
        padding: 0 !important;
        inset: 0 !important;
        .v-icon {
          margin-top: 3px;
          margin-left: -13px;
        }
      }
    }
  }
  .v-card.highlighted { 
    background-color: rgba(255, 166, 0, 0.1);
    // p { color: white !important; }
    .trailing .v-icon { color: rgba(255, 166, 0, 1) !important; }
  }

</style>

